export default "__VITE_ASSET__BlPmk5Pl__"